import React from 'react';
import { getWorkspaces } from '../api/workspace-service.js';

function usePaginatedWorkspaces(initialPage = 1, initialPageSize = 10, agencyId = null) {
  const [page, setPage] = React.useState(initialPage);
  const [pageSize, setPageSize] = React.useState(initialPageSize);
  const [workspaces, setWorkspaces] = React.useState([]);
  const [totalCount, setTotalCount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const fetchPage = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getWorkspaces({ page, pageSize, agencyId });
      setWorkspaces(response.data.results);
      setTotalCount(response.data.totalCount);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [page, pageSize, agencyId]);

  React.useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  return {
    workspaces,
    loading,
    error,
    page,
    pageSize,
    setPage,
    setPageSize,
    refresh: fetchPage,
    totalCount,
  };
}

export default usePaginatedWorkspaces;
